import styled from 'styled-components';
import { width } from '../SaveButton';

export default styled.div`
  color: #27c441;
  font-weight: bold;
  float: left;
  width: ${`calc(100% - ${width})`};
`;
